__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "csh5";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("axios", "0.19.2", function() { return __webpack_require__.e(2667).then(function() { return function() { return __webpack_require__(42667); }; }); });
			register("axios", "0.27.2", function() { return __webpack_require__.e(1676).then(function() { return function() { return __webpack_require__(91676); }; }); });
			register("dayjs", "1.11.13", function() { return __webpack_require__.e(6287).then(function() { return function() { return __webpack_require__(56287); }; }); });
			register("dayjs", "1.11.20", function() { return __webpack_require__.e(4657).then(function() { return function() { return __webpack_require__(44657); }; }); });
			register("vant", "3.6.12", function() { return Promise.all([__webpack_require__.e(9996), __webpack_require__.e(7184), __webpack_require__.e(5072), __webpack_require__.e(790), __webpack_require__.e(1176), __webpack_require__.e(1052), __webpack_require__.e(1484)]).then(function() { return function() { return __webpack_require__(11052); }; }); });
			register("vue-router", "4.4.5", function() { return Promise.all([__webpack_require__.e(1969), __webpack_require__.e(1484), __webpack_require__.e(6547)]).then(function() { return function() { return __webpack_require__(41969); }; }); });
			register("vue", "3.5.12", function() { return Promise.all([__webpack_require__.e(8230), __webpack_require__.e(3280)]).then(function() { return function() { return __webpack_require__(53280); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};